/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBasketBolt = createReactComponent("outline", "basket-bolt", "IconBasketBolt", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M13 20h-5.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.358 2.04", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-4" }]]);

export { IconBasketBolt as default };
//# sourceMappingURL=IconBasketBolt.mjs.map
